<div class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="modalTitle" style="display: block;" aria-modal="true">
  <div class="modal-dialog modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalTitle">Hold Transactions</h4>
        <button type="button" class="close" (click)="close()" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">

        <div class="form-group row">
          <label class="col-3 col-form-label">Hold Reason</label>
          <div class="col-9">
            <textarea [(ngModel)]="reason" class="form-control" rows="5"></textarea>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-info waves-effect waves-light mr-1" (click)="close('single')"><i class="mdi mdi-pause-circle-outline mr-1"></i> <span>Hold Single</span></button>
        <button type="button" class="btn btn-warning waves-effect waves-light mr-1" (click)="close('merchant')"><i class="mdi mdi-pause-circle-outline mr-1"></i> <span>Hold Merchant</span></button>
        <button type="button" class="btn btn-warning waves-effect waves-light mr-1" (click)="close('terminal')"><i class="mdi mdi-pause-circle-outline mr-1"></i> <span>Hold Terminal</span></button>
        <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
      </div>
    </div>
  </div>
</div>
